// covered-by: frontends/carrie/src/ask-v2/shell/__tests__/AskV2Shell.test.tsx
// eslint-disable-next-line import/named
import { createRoute } from "@tanstack/react-router";

import { askV2AuthLayoutRoute } from "./authLayout";

import { AskV2Shell } from "../shell/AskV2Shell";

export const askV2IndexRoute = createRoute({
  getParentRoute: () => askV2AuthLayoutRoute,
  path: "/",
  component: AskV2Shell,
});
